import { Subscription } from "@appTypes/index";
import useRenewPremiumSubscription from "@hooks/useRenewPremiumSubscription";
import useSegment from "@hooks/useSegment";
import { ANALYTICS_EVENTS, ANALYTICS_LOCATIONS } from "@appTypes/analytics";

const useEnablePremiumAutoRenewalBanner = (subscription: Subscription) => {
  const { handleRenew, isRenewing, renewError } = useRenewPremiumSubscription(subscription);
  const { trackEvent } = useSegment();

  const handleRenewWithTracking = async () => {
    trackEvent(
      ANALYTICS_EVENTS.FEATURE_ENGAGED,
      "Premium Auto-Renew Banner - Renew button clicked",
      ANALYTICS_LOCATIONS.SUBSCRIPTIONS_LIST
    );
    await handleRenew();
  };

  return { handleRenew: handleRenewWithTracking, isRenewing, renewError };
};

export default useEnablePremiumAutoRenewalBanner;